import { motion } from "framer-motion";

export default function About() {
  return (
    <div
      className="flex flex-col lg:flex-row gap-12 lg:gap-32 justify-center items-center mt-16 scroll-mt-36 px-4 lg:px-0 overflow-hidden w-full"
      id="about"
    >
      {/* Left Side - Images */}
      <div className="w-full lg:w-[40%] relative flex flex-col items-center">
        <motion.img
          whileHover={{ scale: 1.08, boxShadow: "0 8px 32px rgba(0,0,0,0.25)" }}
          transition={{ type: "spring", stiffness: 300, damping: 20 }}
          src={require("./gloves.jpeg")}
          className="relative mt-[-40px] w-[250px] sm:w-[300px] lg:w-[350px] max-w-full h-auto cursor-pointer"
          alt="main"
        />

        {/* Experience Box */}
        <motion.div
          className="border-2 bg-white border-zinc-200 rounded-t-3xl rounded-br-[5vh] z-40 mt-[-60px] sm:mt-[-80px] flex flex-col justify-center items-center text-center p-4 w-[200px] h-[200px] sm:w-[230px] sm:h-[230px]"
          initial={{ opacity: 0, y: 150 }}
          whileInView={{ opacity: 1, y: 7 }}
          transition={{ duration: 1 }}
          viewport={{ once: false, amount: 0.1 }}
        >
          <div className="text-red-500 text-5xl sm:text-6xl font-bold leading-tight">
            30
          </div>
          <h3 className="font-semibold text-md sm:text-lg">
            Years of Experience
          </h3>
        </motion.div>
      </div>

      {/* Right Side - Text */}
      <div className="w-full lg:w-[55%] space-y-6 text-center lg:text-left">
        <h6 className="text-red-500 font-bold text-2xl sm:text-3xl mt-10">
          ABOUT SSPC
        </h6>

        <h1 className="text-3xl sm:text-4xl font-bold font-serif">
          PIONEERS IN PEST <br /> CONTROL SINCE{" "}
          <span className="font-sans">1995.</span>
        </h1>

        <p className="text-zinc-600 text-sm sm:text-base leading-relaxed">
          <span className="text-red-500 font-semibold">SAI SUCHITH </span>has
          been a trusted name in pest control and hygiene services, delivering
          effective solutions to residential, commercial, and industrial
          sectors.
          <br />
          With decades of experience in the field, we are fully equipped with
          modern treatment methods, advanced equipment, and skilled technicians
          to ensure complete pest control.
        </p>

        <p className="text-zinc-600 text-sm sm:text-base leading-relaxed">
          Our{" "}
          <span className="text-red-500 font-semibold">
            continuous research and innovation
          </span>{" "}
          in pest management techniques have made us{" "}
          <span className="text-red-500 font-semibold">industry leaders</span>,
          providing safe, reliable, and result-oriented services. <br />
          We take pride in our commitment to customer satisfaction and offer the
          best pest control solutions tailored to your specific needs.
        </p>

        <p className="text-zinc-600 text-sm sm:text-base leading-relaxed">
          <span className="text-red-500 font-semibold">SAI SUCHITH </span> uses
          proven and tested pesticides that are
          <span className="text-red-500 font-semibold ml-1">
            highly effective against pests,
          </span>{" "}
          rodents, and termites while being{" "}
          <span className="text-red-500 font-semibold">
            safe for humans, property, and furniture.
          </span>{" "}
          <br />
          Our <span className="text-red-500 font-semibold">
            eco-friendly
          </span>{" "}
          and{" "}
          <span className="text-red-500 font-semibold">
            affordable services
          </span>{" "}
          cover homes, hotels, offices, hospitals, warehouses, and more. <br />
          With professional expertise and cost-effective solutions, we ensure a
          pest-free environment without compromising your safety.
        </p>
      </div>
    </div>
  );
}
